import { render } from "./table_control.vue?vue&type=template&id=4cca2b07"
import script from "./table_control.vue?vue&type=script&lang=js"
export * from "./table_control.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__